import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page8',
  templateUrl: './page8.component.html',
  styleUrls: ['./page8.component.css']
})
export class Page8Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
